<template>
  <v-dialog v-model="dialog" max-width="600" scrollable>
    <v-card v-if="taskData">
      <v-card-title class="primary white--text">
        <v-icon left color="white">mdi-clipboard-text</v-icon>
        Task Details
      </v-card-title>
      <v-card-text class="pt-4">
        <!-- Title -->
        <div class="mb-3">
          <div class="caption grey--text">Title</div>
          <div class="text-h6">{{ taskData.title }}</div>
        </div>

        <!-- Description -->
        <div v-if="taskData.description" class="mb-3">
          <div class="caption grey--text">Description</div>
          <div class="body-1" style="white-space: pre-wrap">
            {{ taskData.description }}
          </div>
        </div>

        <v-divider class="my-3"></v-divider>

        <!-- Details grid -->
        <v-row dense>
          <v-col cols="6" v-if="taskData.priority">
            <div class="caption grey--text">Priority</div>
            <v-chip small :color="priorityColor(taskData.priority)" dark>
              {{ priorityLabel(taskData.priority) }}
            </v-chip>
          </v-col>
          <v-col cols="6" v-if="taskData.category">
            <div class="caption grey--text">Category</div>
            <div class="body-2">{{ taskData.category }}</div>
          </v-col>
          <v-col cols="6" v-if="taskData.scheduled_time">
            <div class="caption grey--text">Scheduled Time</div>
            <div class="body-2">{{ taskData.scheduled_time }}</div>
          </v-col>
          <v-col cols="6" v-if="taskData.recurrence">
            <div class="caption grey--text">Recurrence</div>
            <div class="body-2">{{ taskData.recurrence }}</div>
          </v-col>
          <v-col cols="6" v-if="taskData.start_date">
            <div class="caption grey--text">Start Date</div>
            <div class="body-2">{{ taskData.start_date }}</div>
          </v-col>
          <v-col cols="6" v-if="taskData.end_date">
            <div class="caption grey--text">End Date</div>
            <div class="body-2">{{ taskData.end_date }}</div>
          </v-col>
          <v-col cols="6" v-if="assignedByName">
            <div class="caption grey--text">Assigned By</div>
            <div class="body-2">{{ assignedByName }}</div>
          </v-col>
          <v-col cols="6" v-if="logDate">
            <div class="caption grey--text">Date</div>
            <div class="body-2">{{ logDate }}</div>
          </v-col>
        </v-row>

        <!-- Remarks Section -->
        <div v-if="taskRemarks.length > 0" class="mt-4">
          <v-divider class="mb-3"></v-divider>
          <div class="subtitle-2 mb-2">
            <v-icon small class="mr-1">mdi-comment-text-multiple</v-icon>
            Remarks ({{ taskRemarks.length }})
          </div>
          <div v-for="(r, i) in taskRemarks" :key="i" class="d-flex mb-2">
            <v-icon
              small
              class="mr-2 mt-1"
              :color="r.status_set === 'ongoing' ? 'orange' : 'grey'"
            >
              {{
                r.status_set === "ongoing"
                  ? "mdi-progress-clock"
                  : "mdi-clock-outline"
              }}
            </v-icon>
            <div class="flex-grow-1">
              <div class="body-2">{{ r.remark }}</div>
              <div class="caption grey--text">
                <v-chip
                  x-small
                  :color="r.status_set === 'ongoing' ? 'orange' : 'grey'"
                  dark
                  class="mr-1"
                >
                  {{ r.status_set === "ongoing" ? "Ongoing" : "Pending" }}
                </v-chip>
                {{ r.user ? r.user.full_name : "" }}
                &middot;
                {{ formatDate(r.created_at) }}
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TaskDetailDialog",
  props: {
    value: { type: Boolean, default: false },
    task: { type: Object, default: null },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    taskData() {
      if (!this.task) return null;
      // Handle both task log objects (with nested .task) and direct task objects
      return this.task.task ? this.task.task : this.task;
    },
    assignedByName() {
      if (!this.taskData) return "";
      if (this.taskData.assigned_by && this.taskData.assigned_by.full_name) {
        return this.taskData.assigned_by.full_name;
      }
      return "";
    },
    logDate() {
      if (!this.task) return "";
      // log_date lives on the task log wrapper, not the nested task
      if (this.task.log_date) return this.task.log_date.substr(0, 10);
      return "";
    },
    taskRemarks() {
      if (!this.task) return [];
      // Remarks live on the task log wrapper
      return this.task.remarks || [];
    },
  },
  methods: {
    priorityColor(p) {
      return p === "very_urgent" ? "red" : p === "urgent" ? "orange" : "blue";
    },
    priorityLabel(p) {
      return p === "very_urgent"
        ? "Very Urgent"
        : p === "urgent"
        ? "Urgent"
        : "Basic";
    },
    formatDate(d) {
      if (!d) return "";
      return new Date(d).toLocaleString();
    },
  },
};
</script>
